// Import model
import { Submission } from '../models/Submission';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Submission - handles JSON serialization and deserialization with type validation
 */
export class SubmissionSerializer {
  /**
   * Deserializes a JSON string into a Submission instance
   */
  static deserialize(json: string): Submission {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Submission instance
   */
  static fromObject(obj: any): Submission {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Submission');
    }


    const instance: Submission = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      lastModifiedOn: obj['LastModifiedOn'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      flowIdName: obj['flowId|Name'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Submission instances
   */
  static deserializeArray(json: string): Submission[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Submission instance to a JSON string
   */
  static serialize(instance: Submission): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Submission instance to a plain object
   */
  static toObject(instance: Submission): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'LastModifiedOn': instance.lastModifiedOn,
      'flowId': instance.flowId,
      'flowId|Name': instance.flowIdName,
      'isActive': instance.isActive,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
    };
  }

  /**
   * Serializes an array of Submission instances to a JSON string
   */
  static serializeArray(instances: Submission[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
